{
  "shipping_methods_empty_state": {
    "title": "Manage your shipping methods",
    "description": "Shipping methods let you configure shipping for your B2B customers.",
    "create": "Create shipping method"
  },
  "delete_shipping_method_modal": {
    "title": "Delete shipping method?",
    "body": "Are you sure you want to delete \"{name}\"?"
  },
  "shipping_band_builder": {
    "title": "Shipping band {i}",
    "title_with_name": "Shipping band {i} ({name})",
    "name": {
      "label": "Shipping band name (internal)",
      "placeholder": "e.g. Free shipping threshold",
      "description": "Note: this will not be shown to customers during checkout"
    },
    "no_bands": "Please create a shipping band",
    "actions": {
      "new": "New shipping band"
    }
  },
  "band_cost": {
    "label": "Shipping band cost type",
    "options": {
      "free": "Free",
      "fixed_price": "Fixed price",
      "percent_net_total": "Percentage of net total",
      "custom": "Custom message"
    },
    "fixed_price": {
      "label": "Price",
      "placeholder": "e.g. 10"
    },
    "percent_net_total": {
      "label": "Percentage",
      "placeholder": "e.g. 10"
    },
    "custom": {
      "label": "Language string",
      "info": "To enable a custom shipping message, please add this language string to your website."
    }
  },
  "band_requirement": {
    "label": "Applicable conditions",
    "options": {
      "none": "None",
      "net_total": "Net total",
      "weight": "Weight"
    },
    "net_total": {
      "from": {
        "label": "From net total",
        "placeholder": "e.g. 10"
      },
      "to": {
        "label": "To net total",
        "placeholder": "e.g. 1000"
      },
      "info": "The shipping band will be applied when the net total of the order is greater than or equal to the \"From net total\" and <strong>less than</strong> the \"To net total\"."
    },
    "weight": {
      "from": {
        "label": "From weight (grams)",
        "placeholder": "e.g. 10"
      },
      "to": {
        "label": "To weight (grams)",
        "placeholder": "e.g. 1000"
      },
      "info": "The shipping band will be applied when the total weight of the order is greater than or equal to the \"From weight\" and <strong>less than</strong> the \"To weight\"."
    },
    "none": {
      "info": "Conditions let you specify when this shipping band applies."
    }
  },
  "shipping_method_builder": {
    "header": {
      "title": {
        "create": "Create shipping method",
        "edit": "Edit shipping method"
      },
      "description": "Start by setting the shipping method details, then configure which regions and customer groups it applies to. Finally, create at least one band to set the price and requirements."
    },
    "details": {
      "title": "Method details",
      "name": {
        "label": "Name",
        "placeholder": "e.g. Express Shipping",
        "description": "This will be shown to customers during checkout"
      },
      "sku": {
        "label": "Shipping SKU",
        "placeholder": "e.g. express-shipping",
        "description": "This needs to be a unique ID"
      },
      "priority": {
        "label": "Priority",
        "placeholder": "e.g. 1",
        "description": "Specify the order this shows to customers in your list of shipping methods (e.g. enter 1 to make it show as the first option)"
      },
      "customer_groups": {
        "label": "Customer groups",
        "placeholder": "Select groups",
        "no_options": "No groups found",
        "tooltip": "Select \"Base\" to apply the shipping method to all customer groups"
      }
    },
    "regions": {
      "title": "Shipping regions",
      "countries": {
        "label": "Available countries"
      },
      "regions": {
        "label": "Available regions for {country}"
      }
    },
    "actions": {
      "create": "Create shipping method",
      "update": "Update shipping method"
    },
    "notifications": {
      "success": {
        "create_successful": "Shipping method \"{name}\" successfully created",
        "update_successful": "Shipping method \"{name}\" successfully updated"
      }
    }
  },
  "shipping_auto_selection_card": {
    "title": "Automatic shipping selection",
    "description": "Choose how SparkLayer pre-selects a Shopify shipping method when a B2B order reaches checkout. This only sets the starting selection: customers can still switch to any other available method, and a method they have already chosen is never overridden.",
    "options": {
      "first_available": {
        "label": "First available method (default)",
        "description": "Pre-selects whichever method Shopify returns first, regardless of price. If a free shipping rate comes back first, free shipping becomes the default."
      },
      "cheapest_non_free": {
        "label": "Prefer cheapest paid method",
        "description": "Pre-selects the lowest-priced method that is not free, so a free rate does not become the default. If every available method is free, the first one is used."
      }
    }
  }
}
